module.exports = __webpack_public_path__ + "static/media/filter-icon.886affe6.svg";